import Common from "../../../Common";

interface CreateBody {
	active?: string
	set_uc_to_busy_if_in_call?: string
}

const Setting = class extends Common {
	browse = () => this.get('/teams/presence/setting')

	/** Also used for updating */
	create(body: CreateBody) {
		return this.post('/teams/presence/setting', body)
	}
}

export default Setting;
